'use client';

import { ModalService, type QRScannerProps } from '@capsicum/common-web';
import React from 'react';

import { ScannerModal } from './components/ScannerModal';

type UseQRScannerModalProps = {
	innerStyle?: QRScannerProps['innerStyle'];
	onScanSuccess: QRScannerProps['onScanSuccess'];
	options?: QRScannerProps['options'];
};

export const useQRScannerModal = (props: UseQRScannerModalProps) => {
	const openQRScanner = () => {
		ModalService.addModal({
			background: 'transparent',
			detached: false,
			fullHeight: true,
			isClosable: false,
			renderComponent: () => <ScannerModal clearModals={ModalService.clearModals} {...props} />
		});
	};

	return {
		openQRScanner
	};
};
